import { FormArray, FormGroup, ValidatorFn } from '@angular/forms';

export function almenosUnImpactoValidator(): ValidatorFn {
    return function validate(formGroup: FormGroup) {
        let impactos = 0;

        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];

            if (control.value !== '' && control.value !== null) {
                impactos++;
            }
        });

        if (impactos < 1) {
            return {
                almenosUnImpacto: true
            };
        }

        return null;
    };
}


export function minSeleccionadoCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
        const totalSeleccionados = formArray.controls
        // obtener el valor del checkbox
        .map(control => control.value)
        // total de checkbox seleccionados
        .reduce((prev, next) => next ? prev + next : prev, 0);

        // si el total es menor al minimo regresar error
        return totalSeleccionados >= min ? null : {
            required: true
        };
    };

    return validator;
}


export function almenosUnTipoUsuarioValidator(): ValidatorFn {
    return function validate(formGroup: FormGroup) {
        let users = 0;
        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];

            if (control.value !== '' && control.value !== null) {
                users++;
            }
        });

        if (users < 1) {
            return {
                almenosUnTipoUsuario: true
            };
        }

        return null;
    };
}


export function almenosUnCampoValidator(): ValidatorFn {
    return function validate(formGroup: FormGroup) {
        let campos = 0;
        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];
            if (control.value !== '' && control.value !== null) {
                campos++;
            }
        });

        if (campos < 1) {
            return {
                almenosUnCampo: true
            };
        }
        return null;
    };
}

